import { Datasource, IDatasource } from 'utility-ts-orm';
import { APCustomText } from './../builders/custom_text_builder';

export interface IAPCustomTextDatasource extends IDatasource<APCustomText> {}

angular.module('capability-ng-academic-planner').factory('ngAPCustomTextDatasource', () => {
  return new Datasource<APCustomText, {}>({
    builderType: APCustomText,
    updateMode: 'merge',
    autoId: false
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/custom_texts/datasources/custom_text_datasource.ts